import React, { ReactNode } from "react";
import * as S from "../style";
import Svg from "@components/svg";
import Button from "@components/button";
import theme from "@utils/theme";
import { DownloadIcon } from "lucide-react";

const SearchInput = ({
  searchInput,
  setSearchInput,
  placeholder,
  hasButton = false,
  buttonLabel = "Download",
  onButtonClick,
  icon,
  styleSearchLeftText,
  text,
  styleText,
  hasChildren,
  children,
}: {
  searchInput: string;
  setSearchInput: (val: string) => void;
  placeholder: string[];
  hasButton?: boolean;
  buttonLabel?: string;
  onButtonClick?: () => void;
  icon?: string;
  hasText?: boolean;
  text?: string;
  styleText?: React.CSSProperties;
  hasChildren?: boolean;
  children?: ReactNode;
  styleSearchLeftText?: string;
}) => {
  return (
    <S.StyleTableSearchWrapper>
      {!!text && (
        <S.Text style={{ ...styleText }}>
          {typeof icon === "string" ? (
            <Svg src={icon} styleSvg="transform:translateY(1px)" />
          ) : (
            icon
          )}

          {text}
        </S.Text>
      )}
      {!!hasChildren && <div style={{ flex: 1 }}>{children}</div>}
      <S.SearchInputWrapper>
        <S.StyleTableSearchInput
          type="text"
          placeholder={"Search Here"}
          value={searchInput}
          onChange={(e) => setSearchInput(e.target.value)}
        />
        {!!hasButton && (
          <Button
            icon={<DownloadIcon width={18} />}
            title={"Download"}
            onClick={onButtonClick}
            styleButton={`
            background:transparent;
            border:1px solid ${theme.colors.primary};
            color:${theme.colors.primary};

            `}
          />
        )}
      </S.SearchInputWrapper>
    </S.StyleTableSearchWrapper>
  );
};

export default SearchInput;
